import { axiosInstance } from "../../../config/api/Axios";

export const getDataRequestsApi = async (organization_id, params = { start: 1 }) =>
    axiosInstance.get(`/organizations/${organization_id}/company-requests`, { params });
